import "./Resources.module.css";
import Header from "@/reusable_sections/Header";
import ResourceLibrary from "./sections/ResourceLibrary";
import Footer from "@/reusable_sections/Footer";
export default function ResourcesPage() {
  return <div>
      <Header />
      <ResourceLibrary />
      <Footer />
    </div>;
}